import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ChatbotWidget from "./components/ChatbotWidget";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Servicios from "./pages/Servicios";
import PaquetesPrecios from "./pages/PaquetesPrecios";
import QuienesSomos from "./pages/QuienesSomos";
import Contacto from "./pages/Contacto";
import Gracias from "./pages/Gracias";
import PoliticaPrivacidad from "./pages/PoliticaPrivacidad";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/servicios" element={<Servicios />} />
            <Route path="/paquetes-precios" element={<PaquetesPrecios />} />
            <Route path="/quienes-somos" element={<QuienesSomos />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/gracias" element={<Gracias />} />
            <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
          </Routes>
          <Footer />
          <ChatbotWidget />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
